/* eslint-disable no-useless-catch */
/* eslint prefer-const: 0 */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/**
 * @copyright (C) 2023, Rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of Rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by Rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import dayjs, { Dayjs } from "dayjs";
import DetectRTC from "detectrtc";
import isArray from "lodash-es/isArray";
import isEmpty from "lodash-es/isEmpty";
import isFunction from "lodash-es/isFunction";
import isNil from "lodash-es/isNil";
import isObject from "lodash-es/isObject";
import isString from "lodash-es/isString";
import keys from "lodash-es/keys";
import map from "lodash-es/map";
import transform from "lodash-es/transform";
import isEqual from "lodash-es/isEqual";
import { isIOS, isIOS13 } from "react-device-detect";
import { Subscription, timer } from "rxjs";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { Properties } from "../properties";
import { sha256 } from "./crypto";
import Environments from "./environments";
import RDate from "./date";
import { Configure } from "./configure";
import { z } from "zod";
import { RegExp as regExp } from "@/frameworks/core/commons";

function compare(objValue: any, othValue: any) {
	if (objValue === othValue) {
		return true;
	}
	return false;
}

class UtilityStatic {
	public isNil(value: any) {
		return isNil(value);
	}

	public isNotNil(value: any) {
		return this.isNil(value) === false;
	}

	public isEmpty(value: any) {
		return isEmpty(value);
	}

	public isNotEmpty(value: any) {
		return this.isEmpty(value) === false;
	}

	public isObject(value: any) {
		return isNil(value) ? false : isArray(value) === false && isObject(value);
	}
	public isArray(value: any) {
		return isNil(value) ? false : isArray(value) && isObject(value);
	}

	public isEmptyString(str: string) {
		return this.isNil(str) || (typeof str === "string" && str === "") || str.length <= 0;
	}
	public isNotEmptyString(str: string) {
		return !this.isEmptyString(str);
	}

	public isEqual(value: any, other: any) {
		throw new Error("Instead of comparing these two objects directly, please use the lodash-es/isEqual method");
		// return isEqualWith(value, other, compare);
	}

	public isMatch = (srcData: any, regExp: any): boolean => regExp.test(srcData);
	public isMatchHash(regExp: any) {
		return this.hasURLHash && this.isMatch(this.URLHash(), regExp);
	}

	public get platform() {
		const getPlatform = (platforms: { string: string; subString: string; identity: string }[]) => {
			for (let i = 0; i < platforms.length; i++) {
				if (platforms[i].string && platforms[i].string.indexOf(platforms[i].subString) !== -1) {
					if (platforms[i].identity === "Mac" && (isIOS || isIOS13)) {
						return "iOS";
					}
					return platforms[i].identity;
				}
			}
		};
		return getPlatform([
			{ string: navigator.platform, subString: "Win", identity: "Win" },
			{ string: navigator.platform, subString: "Mac", identity: "Mac" },
			{ string: navigator.userAgent, subString: "iPhone", identity: "iOS" },
			{ string: navigator.userAgent, subString: "iPad", identity: "iOS" },
			{ string: navigator.userAgent, subString: "Windows CE", identity: "WM" },
			{ string: navigator.userAgent, subString: "Android", identity: "Android" },
			{ string: navigator.platform, subString: "Linux", identity: "Linux" }
		])?.toLowerCase();
	}

	public isChrome = DetectRTC.browser.isChrome || false;
	public isFirefox = DetectRTC.browser.isFirefox || false;
	public isEdge = DetectRTC.browser.isEdge || false;
	public isSafari = DetectRTC.browser.isSafari || false;
	public get isAndroid() {
		return this.platform === "android";
	}
	public get isIOS() {
		return this.platform === "ios";
	}
	public get isMac() {
		return this.platform === "mac";
	}
	public get isWindows11() {
		return this._is_windows11;
	}
	private _is_windows11() {
		return (async () => {
			try {
				// @ts-ignore
				const ua = await navigator.userAgentData.getHighEntropyValues(["platformVersion"]);
				// @ts-ignore
				if (navigator.userAgentData.platform === "Windows") {
					const majorPlatformVersion = parseInt(ua.platformVersion.split(".")[0]);
					if (majorPlatformVersion >= 13) {
						return true;
					}
				}
				return false;
			} catch (error) {
				return false;
			}
		})();
	}
	public get isMobile() {
		return DetectRTC.isMobileDevice || this.isIOS;
	} // for IOS 데스크탑모드
	public get isChromeOS() {
		return /CrOS/.test(navigator.userAgent);
	} // Chrom OS 체크
	public get isLGTV() {
		const isLGTVPWA = !!window.navigator.userAgent.match(/SmartTV/) && !!window.navigator.userAgent.match(/PWA/);
		return (
			(!!window.navigator.userAgent.match(/NetCast/) && navigator.userAgent.indexOf("Colt/") >= 0) || isLGTVPWA
		);
	}

	public get language() {
		// @ts-ignore
		const currentLanguage = navigator.language || navigator.userLanguage;
		return currentLanguage.split("-")[0];
	}

	public browserVersion = DetectRTC.browser.version;
	public browserFullVersion = DetectRTC.browser.fullVersion;
	public get browserName() {
		return `${DetectRTC.browser.name} (${this.browserFullVersion})`;
	}

	public get safariVersion() {
		return this.isSafari ? Number(navigator.userAgent.split("Version/")[1].split(" ")[0].split(".")[0]) : -1;
	}

	public get isBrowserRefreshed() {
		try {
			// 브라우저 새로고침 감지
			if (window.performance) {
				// safari 14 버전에서는 getEntriesByType('navigation') 가 빈 배열 이기 때분에 조건 추가
				if (this.safariVersion > 0 && this.safariVersion < 15) {
					// @ts-ignore
					return window.performance.navigation.type === 1;
				}

				if (window.performance.getEntriesByType("navigation").length) {
					// @ts-ignore
					return window.performance.getEntriesByType("navigation")[0].type === "reload";
				}
			} else {
				throw new Error("window.performance not supported");
			}
		} catch (error) {
			// 지원하지 않는 경우 재입장으로 체크
			console.warn(error);
			return false;
		}
	}

	public get vender() {
		const info = this.GPUInfo;
		return info.vendor || "unknown";
	}

	public get isGraphicAccelerationEnabled() {
		return this.vender.toLowerCase().includes("google");
	}

	public get GPUInfo() {
		try {
			const gl = document.createElement("canvas").getContext("webgl");
			const ext = gl?.getExtension("WEBGL_debug_renderer_info");
			const result = ext
				? {
						vendor: gl?.getParameter(ext.UNMASKED_VENDOR_WEBGL),
						renderer: gl?.getParameter(ext.UNMASKED_RENDERER_WEBGL)
					}
				: {
						vendor: "unknown",
						renderer: "unknown"
					};
			gl?.getExtension("WEBGL_lose_context")?.loseContext();
			return result;
		} catch {
			return {
				vendor: "unknown",
				renderer: "unknown"
			};
		}
	}

	public get isWebGLSupported(): boolean {
		return this.isGraphicAccelerationEnabled;
		// if (this._isWebGLSupported === null) {
		// 	let gl = document.createElement("canvas").getContext("webgl2");
		// 	if (!gl) {
		// 		if (typeof WebGL2RenderingContext !== "undefined") {
		// 			console.warn("your browser appears to support WebGL2 but it might be disabled. Try updating your OS and/or video card drivers");
		// 		} else {
		// 			console.warn("your browser has no WebGL2 support at all");
		// 		}
		// 		this._isWebGLSupported = false;
		// 	} else {
		// 		const ext = gl.getExtension('WEBGL_debug_renderer_info');
		// 		this._isWebGLSupported = true;
		// 	}
		// 	gl?.getExtension('WEBGL_lose_context')?.loseContext();
		// 	gl = null;
		// }
		// return this._isWebGLSupported;
	}

	public download(url: string, option: { id?: string } = { id: "iframe" }) {
		let downloadFrame: HTMLIFrameElement | null = document.getElementById(option.id!) as HTMLIFrameElement;
		if (this.isNil(downloadFrame)) {
			downloadFrame = document.createElement("iframe") as HTMLIFrameElement;
			downloadFrame.id = option.id!;
			downloadFrame.style.width = "0";
			downloadFrame.style.height = "0";
			downloadFrame.style.display = "none";
			document.body.appendChild(downloadFrame);
		}
		if (downloadFrame) {
			downloadFrame.src = url;
		}
	}

	public format(message: string, ...parameters: any[]) {
		let index = 0;
		for (const parameter of parameters) {
			let value = "";
			if (this.isArray(parameter) || this.isObject(parameter)) {
				value = JSON.stringify(parameter, null);
			} else {
				value = parameter;
			}
			message = message.replace(new RegExp(`%${index}`, "gi"), value);
			index++;
		}
		for (let _index = index; _index < index + 20; _index++) {
			message = message.replace(new RegExp(`%${index}`, "gi"), "");
		}
		return message;
	}

	public formatArguments(...parameters: any[]) {
		if (!!console.info && !!console.log && !!console.log) {
			if (parameters.length > 0) {
				let message = "%0 %1 %2 %3 %4 %5 %6 %7 %8 %9";
				let index = 0;
				for (const parameter of parameters) {
					let value = "";
					if (this.isArray(parameter)) {
						const keys = Object.keys(parameter);
						for (const key of keys) {
							// @ts-ignore
							value += key + " = " + this.formatArguments(parameter[key]) + ", ";
						}
						value = "[ " + value.substring(0, value.length - 2) + " ]";
					} else if (this.isObject(parameter)) {
						const keys = Object.keys(parameter);
						for (const key of keys) {
							// @ts-ignore
							value += key + " = " + this.formatArguments(parameter[key]) + ", ";
						}
						value = "{ " + value.substring(0, value.length - 2) + " }";
					} else {
						value = parameter;
					}
					message = message.replace(new RegExp(`%${index}`, "gi"), value);
					index++;
				}
				for (let _index = index; _index < index + 20; _index++) {
					message = message.replace(new RegExp(` %${_index}`, "gi"), "");
				}
				return message;
			}
		}
		return "";
	}

	// @ts-ignore
	public changeRun(checker, task, timeout = 0, ...parameter) {
		if (this.isNil(checker) || this.isNil(task) || typeof checker !== "function" || typeof task !== "function") {
			return false;
		}
		let oldChecker = checker();
		let timeoutId: Subscription | null = null;
		let runnerId: Subscription | null = null;
		const run = () => {
			const newChecker = checker();
			if (newChecker !== oldChecker) {
				oldChecker = newChecker;
				timeoutId?.unsubscribe();
				timeoutId = null;
				task && task(...parameter);
			} else {
				runnerId = timer(100).subscribe(run);
			}
		};
		if (timeout > 0) {
			timeoutId = timer(timeout).subscribe(() => {
				task = null;
				runnerId?.unsubscribe();
				runnerId = null;
				throw new Error("Task timeout");
			});
		}
		timer(0).subscribe(run);
	}

	// @ts-ignore
	public triggerRun(trigger, task, timeout = 0, ...parameter) {
		if (this.isNil(trigger) || this.isNil(task) || typeof trigger !== "function" || typeof task !== "function") {
			return false;
		}
		let timeoutId: Subscription | null = null;
		let runnerId: Subscription | null = null;
		const run = () => {
			if (trigger()) {
				timeoutId?.unsubscribe();
				timeoutId = null;
				task && task(...parameter);
			} else {
				runnerId = timer(100).subscribe(run);
			}
		};
		if (timeout > 0) {
			timeoutId = timer(timeout).subscribe(() => {
				task = null;
				runnerId?.unsubscribe();
				runnerId = null;
				throw new Error("Task timeout");
			});
		}
		timer(0).subscribe(run);
	}

	public URLHash(index = 0, defValue = "") {
		const hash = window.location.hash.substring(1).split("#");
		if (index >= 0 && index < hash.length) {
			if (this.isEmptyString(hash[index])) {
				return defValue;
			}
			return hash[index];
		} else if (index < 0) {
			return hash.length === 1 && this.isEmptyString(hash[0]) ? defValue : hash;
		}
		return defValue;
	}
	public get hasURLHash() {
		return !!this.URLHash();
	}

	public json = {
		parse: (data: any, defValue: any = null) => {
			let result = data;
			if (this.isNil(result)) {
				return defValue;
			}
			try {
				if (typeof result === "string" && (result.slice(0, 1).match(/{/) || result.match(/true|false/))) {
					result = JSON.parse(result);
				}
			} catch {
				result = defValue;
			}
			return result;
		},
		isJson: (str: string) => {
			try {
				const json = JSON.parse(str);
				return typeof json === "object";
			} catch (e) {
				return false;
			}
		}
	};

	public process = {
		env: (key: string, defValue: any = null) => {
			const result = Environments.values[`REACT_APP_${key}`];
			if (this.isNil(result)) {
				return defValue;
			}
			return result;
		}
	};

	/**
	 * Normalizes the given URL by ensuring it has a valid protocol.
	 *
	 * The method attempts to prepend "https:" to the URL if it's missing a protocol.
	 * It tries up to three times to validate the URL format using the URL constructor.
	 *
	 * @param {Nullable<string>} url - The URL string to be normalized. It can be null or a string.
	 * @return {string} The normalized URL string. If the input is null or cannot be properly normalized, an empty string is returned.
	 */
	public URLNormalize(url: Nullable<string>): string {
		if (url) {
			let count = 3;
			while (count > 0) {
				try {
					new URL(url); // 주어진 URL확인
					break;
				} catch {
					if (!url.startsWith("http")) {
						url = `https:${url}`;
					}
				}
				count--;
			}
			return url;
		} else {
			return "";
		}
	}

	/**
	 * A collection of utility functions for data conversion.
	 */
	public convert = {
		/**
		 * Converts the input data to a boolean value.
		 *
		 * @param {string|boolean} [data] - The data to be converted to boolean.
		 *                                    If the input is a string, it checks if the string is "true".
		 *                                    If the input is a boolean, it returns the value as is.
		 *                                    If the input is undefined, it returns undefined.
		 * @returns {boolean|undefined} - The boolean representation of the input data or undefined.
		 */
		toBoolean: (data?: string | boolean): boolean | undefined => {
			if (typeof data === "string") {
				return data === "true";
			}
			return data;
		},
		/**
		 * Converts a JSON object to a query string.
		 *
		 * @param {object} jsonData - The JSON object to convert.
		 * @returns {string} The resulting query string.
		 */
		jsonToQS: (jsonData: object): string =>
			map(jsonData, (value: any, key: any) => `${key}=${encodeURIComponent(value)}`).join("&"),
		/**
		 * Converts a given URL to use the HTTPS protocol if it starts with HTTP or protocol-relative URL
		 * (e.g., "//example.com"). If the URL contains "localhost" and is protocol-relative, it defaults to HTTP.
		 *
		 * @param {string} url - The URL to be converted.
		 * @returns {string} - The URL with the HTTPS protocol, or HTTP if the URL contains "localhost".
		 */
		toHTTPS: (url: string): string => {
			let _url = url;
			if (this.isNotNil(url)) {
				if (url.startsWith("http:")) {
					_url = url.replace("http:", "https:");
				} else if (url.startsWith("//")) {
					_url = url.indexOf("localhost") < 0 ? `https:${url}` : `http:${url}`;
				}
			}
			return _url;
		},

		/**
		 * Converts a string to JSON if the string represents a valid JSON object or array.
		 * If the string represents a boolean ("true" or "false"), it converts to the corresponding boolean value.
		 * If the input is not a valid JSON*/
		stringToJSON: <T = any>(data: any, defalutValue: T | null = null): T | null => {
			try {
				if (typeof data === "string" && (data === "true" || data === "false")) {
					return JSON.parse(data) as T;
				}
				if (typeof data === "string" && (data.trim().startsWith("{") || data.trim().startsWith("["))) {
					return JSON.parse(data) as T;
				}
				return data as T;
			} catch {
				return defalutValue;
			}
		},
		/**
		 * Converts a JavaScript object or value to a JSON string.
		 *
		 * If the input data is a JavaScript object, it returns the JSON string representation
		 * of that object. If the input data is not an object, it returns the data as it is.
		 * If the input data is null, it returns null.
		 *
		 * @param {any} data - The data to be converted to a JSON string.
		 * @returns {any} The JSON string representation of the object, the original data if
		 * it is not an object, or null if the input data is null.
		 */
		JSONToString: (data: any): any => {
			if (data !== null) {
				if (typeof data === "object") {
					return JSON.stringify(data);
				}
				return data;
			} else {
				return null;
			}
		}
	};

	public async devices() {
		const devices = await navigator.mediaDevices.enumerateDevices();
		let hasCamera = false;
		let hasMic = false;
		let hardware = {};
		let defaultDevice = {
			id: "",
			kind: ""
		};
		for (const device of devices) {
			const data = device.toJSON();
			if (data.deviceId === "default") {
				// @ts-ignore
				if (hardware["default"] === undefined) {
					// @ts-ignore
					hardware["default"] = [];
				}
				// @ts-ignore
				hardware["default"].push(data.groupId);
				defaultDevice.id = data.groupId;
				defaultDevice.kind = data.kind;
				continue;
			}
			const groupId = `${data.groupId}`;
			// @ts-ignore
			if (hardware[groupId] === undefined) {
				// @ts-ignore
				hardware[groupId] = {
					label: data.label,
					devices: []
				};
			}
			data.default = data.groupId === defaultDevice.id && data.kind === defaultDevice.kind;
			// @ts-ignore
			hardware[groupId].devices.push(data);

			if (!hasCamera && device.kind === "videoinput") {
				hasCamera = true;
			}
			if (!hasMic && device.kind === "audioinput") {
				hasMic = true;
			}
		}
		return { devices: hardware, hasCamera, hasMic };
	}

	public omit<T>(o: { [key: string]: T }, key: string) {
		const { [key]: _, ...res } = o;
		return res;
	}

	public isFunctions(obj: any, prop: any) {
		return (
			// @ts-ignore
			!!Object.getOwnPropertyDescriptor(obj, prop)["get"] ||
			// @ts-ignore
			!!Object.getOwnPropertyDescriptor(obj, prop)["set"] ||
			isFunction(obj[prop])
		);
	}

	public pureValues(obj: any) {
		const _keys = keys(obj).filter((key) => {
			if (!this.isFunctions(obj, key)) {
				return obj;
			}
		});
		let result: { [key: string]: any } = {};
		for (let key of _keys) {
			result[key] = obj[key];
		}
		return result;
	}

	public VisibilityOption = {
		get visibilityValue() {
			if (typeof document.hidden !== "undefined") {
				// Opera 12.10 and Firefox 18 and later support
				return "visibilitychange";
				// @ts-ignore
			} else if (typeof document.msHidden !== "undefined") {
				return "msvisibilitychange";
				// @ts-ignore
			} else if (typeof document.webkitHidden !== "undefined") {
				return "webkitvisibilitychange";
			}
			return "visibilitychange";
		},
		get hiddenValue() {
			if (typeof document.hidden !== "undefined") {
				// Opera 12.10 and Firefox 18 and later support
				return "hidden";
				// @ts-ignore
			} else if (typeof document.msHidden !== "undefined") {
				return "msHidden";
				// @ts-ignore
			} else if (typeof document.webkitHidden !== "undefined") {
				return "webkitHidden";
			}
			return "hidden";
		}
	};

	// from lounge
	public findParents(el: HTMLElement | null | undefined, name: string) {
		while ((el = el?.parentElement) && (!el.classList.contains(name) || el.id === name));
		return el;
	}

	public replaceTagToString(text: string) {
		return text.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/&/g, "&amp;");
	}

	public replaceBR(text: string) {
		if (text && text !== "") {
			return text
				.replace(/<br \/>/g, "\n")
				.replace(/<br\/>/g, "\n")
				.replace(/<br>/g, "\n");
		}
		return text;
	}

	public convertTo1ByteChar(x_char: string) {
		let x_2byteChar = "";

		for (let i = 0; i < x_char.length; i++) {
			const code = x_char.charCodeAt(i); // 문자 -> ascii코드

			if (code >= 65281 && code <= 65374 && code != 65340) {
				x_2byteChar += String.fromCharCode(code - 65248);
			} else if (code == 8217) {
				// single quotes
				x_2byteChar += String.fromCharCode(39);
			} else if (code == 8221) {
				// double quotes
				x_2byteChar += String.fromCharCode(34);
			} else if (code == 12288) {
				// space
				x_2byteChar += String.fromCharCode(32);
			} else if (code == 65507) {
				// ~
				x_2byteChar += String.fromCharCode(126);
			} else if (code == 65509) {
				// \
				x_2byteChar += String.fromCharCode(92);
			} else {
				x_2byteChar += x_char.charAt(i);
			}
		}
		return x_2byteChar;
	}

	public blurInput() {
		Array.from(document.getElementsByTagName("input")).forEach(function (el) {
			el.blur();
		});
	}

	public get browserInfo() {
		return {
			name: DetectRTC.browser.name,
			version: DetectRTC.browser.version,
			fullVersion: DetectRTC.browser.fullVersion
		};
	}

	public execClipboard(targetId: string, confirmText: string) {
		const copyText = document.getElementById(targetId) as HTMLTextAreaElement;
		copyText?.select();
		document.execCommand("copy");
		alert(confirmText);
	}

	public get checkMobile() {
		return DetectRTC.isMobileDevice;
	}

	public removeScriptTag(text: string) {
		return text.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
	}

	public removeHtmlTags(text: string): string {
		return text.replace(/<[^>]*>/g, "");
	}

	public get themeColor() {
		if ((window as any).meeting && (window as any).meeting.themeColor) {
			return `#${(window as any).meeting.themeColor.replace("#", "")}`;
		}
		return "#00AC39";
	}

	public digest(data: any) {
		if (isString(data) === false) {
			return sha256(JSON.stringify(data));
		}
		return sha256(data);
	}

	public maybe(options: { if: boolean; okay?: any; else?: any }, defValue: any = {}) {
		if ((options.if && options.okay) || (options.if === false && options.else)) {
			return options.if ? options.okay : options.else;
		}
		return defValue;
	}

	public choice(
		options: {
			select: number;
			cases: any[];
			caseElse?: any;
		},
		defValue: any = {}
	) {
		if (options.select >= 0 && options.cases.length > options.select) {
			return options.cases[options.select];
		}
		if (options.caseElse) {
			return options.caseElse;
		}
		return defValue;
	}
	public decodeJwt(token: string) {
		const base64Url = token.split(".")[1];
		const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split("")
				.map(function (c) {
					return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
				})
				.join("")
		);
		return JSON.parse(jsonPayload);
	}

	/**
	 * Compares the minutes of two timestamps to determine if they are the same.
	 *
	 * @param timestamp1 - The first timestamp in milliseconds since the UNIX epoch.
	 * @param timestamp2 - The second timestamp in milliseconds since the UNIX epoch.
	 * @return True if both timestamps have the same minutes, otherwise false.
	 */
	public areMinutesSame(timestamp1: number, timestamp2: number): boolean {
		const date1 = new Date(timestamp1);
		const date2 = new Date(timestamp2);

		const minutes1 = date1.getMinutes();
		const minutes2 = date2.getMinutes();

		return minutes1 === minutes2;
	}

	/**
	 * Converts bytes into a human-readable string format with the specified number of decimal places.
	 *
	 * @param {number} bytes - The size in bytes to be formatted.
	 * @param {number} [decimals=2] - The number of decimal places to include in the formatted string. Defaults to 2.
	 * @return {string} The formatted string representing the size in a human-readable format (e.g., KB, MB, GB).
	 */
	public formatBytes(bytes: number, decimals: number = 2): string {
		if (bytes === 0) return "0 Bytes";

		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

		const i = Math.floor(Math.log(bytes) / Math.log(k));

		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
	}

	/**
	 * Calculates the difference in days (or other specified units) between two timestamps.
	 *
	 * @param {number} timestamp1 - The first timestamp to compare.
	 * @param {number} timestamp2 - The second timestamp to compare.
	 * @param {dayjs.OpUnitType} [unit="day"] - The unit of time to measure the difference. Defaults to "day".
	 * @return {number} The difference between the two timestamps in the specified units.
	 */
	public getDayDiff(timestamp1: number, timestamp2: number, unit: dayjs.OpUnitType = "day"): number {
		return RDate(RDate(timestamp1).startOf(unit)).diff(RDate(timestamp2).startOf(unit), unit);
	}

	/**
	 * Determines whether a given string is a valid URL.
	 *
	 * @param {string} url - The string to be checked.
	 * @return {boolean} - Returns true if the string is a valid URL, otherwise false.
	 */
	public isURL(url: string): boolean {
		const URLRegex = /^(https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?::\d+)?(\/[^ \n]*)?$/;
		return URLRegex.test(url);
	}

	/**
	 * Extracts all URLs from the given string.
	 *
	 * @param {string} value - The string from which URLs need to be extracted.
	 * @return {RegExpMatchArray | null} An array of matched URLs, or null if no URLs are found.
	 */
	public extract_all_url(value: string): RegExpMatchArray | null {
		return value.match(/(https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?::\d+)?(\/[^ \n]*)?/g);
	}

	/**
	 * Sends data to the specified URL using the Beacon API.
	 *
	 * @param {string} url - The endpoint to which data should be sent.
	 * @param {unknown} [data={}] - The data to be sent in JSON format. Defaults to an empty object.
	 * @return {void}
	 */
	public sendData(url: string, data: unknown = {}): void {
		const headers = { type: "application/json" };
		const blob = new Blob([JSON.stringify(data)], headers);
		const domain = Properties.property.apiDomain;
		const request = `${domain}${!url.startsWith("/") ? "/" : ""}${url}?authorization=${Configure.authorizationKey}`;
		navigator.sendBeacon(request, blob);
	}

	/**
	 * Sanitizes the input string by removing HTML tags.
	 *
	 * @param {string} input - The string to be sanitized.
	 * @returns {string} The sanitized string with HTML tags removed.
	 */
	public sanitizeInput = (input: string): string => {
		return input.replace(/(<)(\/?[^>]+)(>|$)/g, "$1$3");
	};

	/**
	 * Swaps two items in the provided array.
	 *
	 * @template T
	 * @param {T[]} list - The array containing the items to be swapped.
	 * @param {number} fromIndex - The index of the first item to be swapped.
	 * @param {number} toIndex - The index of the second item to be swapped.
	 */
	public swapArrayItem = <T>(list: T[], fromIndex: number, toIndex: number): void => {
		const temp = list[fromIndex];
		list[fromIndex] = list[toIndex];
		list[toIndex] = temp;
	};

	/**
	 * Rounds a given number to a specified number of decimal places.
	 *
	 * @param {number} value - The number to be rounded.
	 * @param {number} decimalPlaces - The number of decimal places to round to.
	 * @returns {number} - The number rounded to the specified decimal places.
	 */
	public roundToDecimal = (value: number, decimalPlaces: number): number => {
		const factor = Math.pow(10, decimalPlaces);
		return Math.round(value * factor) / factor;
	};

	/**
	 * Generates a unique fingerprint for the current browser session using FingerprintJS.
	 *
	 * @return {Promise<string>} A promise that resolves to the unique visitor ID generated.
	 */
	public async fingerprint(): Promise<string> {
		const finger_print = FingerprintJS.load();
		const fprint = await finger_print;
		return (await fprint.get()).visitorId;
	}

	/**
	 * Computes the difference between two objects.
	 *
	 * @param {any} object1 - The first object to compare.
	 * @param {any} object2 - The second object to compare against.
	 * @return {any} An object representing the differences between object1 and object2.
	 */
	public get_difference(object1: any, object2: any): any {
		const changes = (obj: any, base: any) => {
			return transform(obj, (result: any, value, key: string) => {
				if (!isEqual(value, base[key])) {
					result[key] = isObject(value) && isObject(base[key]) ? changes(value, base[key]) : value;
				}
			});
		};
		return changes(object1, object2);
	}

	public emailValidCheck = (email: string) => {
		const emailTrimmed = email.trim();
		return regExp.EMAIL_REG.test(emailTrimmed) && z.string().email().safeParse(emailTrimmed).success;
	};
}

const Utility = Object.freeze(new UtilityStatic());
export default Utility;
